export const TURNSTILE_SITE_KEY = '0x4AAAAAAFfcz1klPOUiOFkm';

const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let scriptPromise = null;

function loadScript() {
    if (window.turnstile) return Promise.resolve();
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = SCRIPT_SRC;
            s.async = true;
            s.defer = true;
            s.onload = resolve;
            s.onerror = () => { scriptPromise = null; reject(new Error('turnstile load failed')); };
            document.head.appendChild(s);
        });
    }
    return scriptPromise;
}

export default {
    data() {
        return {
            turnstileToken: null,
            turnstileWidgetId: null,
            turnstileVisible: false,
            turnstilePendingCb: null,
        };
    },
    mounted() {
        loadScript().catch(() => {});
    },
    beforeUnmount() {
        try {
            if (window.turnstile && this.turnstileWidgetId !== null) {
                window.turnstile.remove(this.turnstileWidgetId);
            }
        } catch (e) {}
    },
    methods: {
        // вызвать cb, когда капча пройдена
        withTurnstile(cb) {
            if (this.turnstileToken) { cb(); return; }
            this.turnstilePendingCb = cb;
            this.turnstileVisible = true;
            loadScript().then(() => this.renderTurnstile()).catch(() => {
                this.turnstilePendingCb = null;
                alert('Не удалось загрузить проверку. Обновите страницу и попробуйте ещё раз.');
            });
        },
        renderTurnstile() {
            if (this.turnstileWidgetId !== null) {
                window.turnstile.reset(this.turnstileWidgetId);
                return;
            }
            this.$nextTick(() => {
                const el = this.$refs.turnstileContainer;
                if (!el) return;
                this.turnstileWidgetId = window.turnstile.render(el, {
                    sitekey: TURNSTILE_SITE_KEY,
                    appearance: 'interaction-only', // виджет виден, только если нужна проверка человеком
                    callback: (token) => {
                        this.turnstileToken = token;
                        const cb = this.turnstilePendingCb;
                        this.turnstilePendingCb = null;
                        if (cb) cb();
                    },
                    'expired-callback': () => { this.turnstileToken = null; },
                    'error-callback': () => {
                        this.turnstileToken = null;
                        this.turnstilePendingCb = null;
                        this.formDisabled = false;
                    },
                });
            });
        },
        // токен одноразовый: после любой неудачи сбрасываем
        resetTurnstile() {
            this.turnstileToken = null;
            try {
                if (window.turnstile && this.turnstileWidgetId !== null) {
                    window.turnstile.reset(this.turnstileWidgetId);
                }
            } catch (e) {}
        },
    },
};